import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import NoticiasPage from './pages/NoticiasPage';
import PerguntasPage from './pages/PerguntasPage';
import PublicacoesPage from './pages/PublicacoesPage';
import ParceirosPage from './pages/ParceirosPage';
import './App.css';

function App() {
  return (
    <ConfigProvider locale={ptBR}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="noticias" element={<NoticiasPage />} />
              <Route path="perguntas" element={<PerguntasPage />} />
              <Route path="publicacoes" element={<PublicacoesPage />} />
              <Route path="parceiros" element={<ParceirosPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
